package pt.at.oss.kotlin.manual.schema.common.contactname.suffixes

import pt.at.oss.kotlin.manual.enumeration.FieldSizeConstants
import pt.at.oss.kotlin.manual.storage.common.contactname.suffixes.SuffixesEntry
import pt.lightweightform.kotlin.schema.RecordSchema
import pt.lightweightform.kotlin.schema.StringSchema
import pt.lightweightform.kotlin.type.validator.ValidationErrors

/**
 * SuffixesEntrySchema Schema object
 *
 * NOTE FOR DEVELOPERS:
 *  - This file was generated. Any modifications to this file will be lost after generation
 * @generated
 */
class SuffixesEntrySchema : RecordSchema<SuffixesEntry>(name = "suffixes") {

    val nameSchema: StringSchema = StringSchema(name = "name", minLength = 1, maxLength = FieldSizeConstants.CONTACT_NAME_SUFFIX_MAX_LEN)
    override fun isValid(value: SuffixesEntry?): Boolean {
        return value == null || (
            nameSchema.isValid(value.name)
            )
    }

    override fun validate(value: SuffixesEntry?, path: String): ValidationErrors {
        val validator = super.validate(value, path)
        if (value === null) {
            return validator
        }
        validator.addErrors(nameSchema.validate(value.name))
        return validator
    }
}
